import React, { useState, useEffect } from 'react';
import { getAdminOrganizationsWithStats, createOrganizationAccount, deleteOrganizationById, updateOrganizationCreditsByAdmin } from '../services/apiService';
import '../styles/adminpage.css';

export default function AdminOrganizationsTab() {
  const [orgs, setOrgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [creationResult, setCreationResult] = useState(null);

  const [formData, setFormData] = useState({
    name: '', contactName: '', email: '', phone: '', credits: ''
  });

  useEffect(() => {
    fetchOrgs();
  }, []);

  const fetchOrgs = async () => {
    setLoading(true);
    try {
      const data = await getAdminOrganizationsWithStats();
      setOrgs(data);
    } catch (err) {
      alert('Organizasyonlar çekilemedi: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const res = await createOrganizationAccount(formData);
      setCreationResult(res);
      fetchOrgs();
    } catch (err) {
      alert('Hata: ' + err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (org) => {
    const confirmed = window.confirm(`"${org.name}" adlı organizasyonu silmek istediğinize emin misiniz?\n\nBu işlem geri alınamaz!`);
    if (!confirmed) return;
    try {
      await deleteOrganizationById(org._id);
      alert(`"${org.name}" başarıyla silindi.`);
      fetchOrgs();
    } catch (err) {
      alert('Silme hatası: ' + err.message);
    }
  };

  const handleUpdateCredits = async (org, amount) => {
    const action = amount > 0 ? "eklemek" : "çıkartmak";
    const confirmed = window.confirm(`"${org.name}" adlı organizasyona ${Math.abs(amount)} kredi ${action} istediğinize emin misiniz?`);
    if (!confirmed) return;
    try {
      await updateOrganizationCreditsByAdmin(org._id, amount);
      fetchOrgs();
    } catch (err) {
      alert('Kredi güncellenemedi: ' + err.message);
    }
  };

  if (loading) return <div>Yükleniyor...</div>;

  return (
    <div>
      <div style={{ marginBottom: 15, display: 'flex', justifyContent: 'flex-end' }}>
        <button className="btn" onClick={() => setIsModalOpen(true)}>+ Yeni Organizasyon Ekle</button>
      </div>

      <div className="table-scroll">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Firma Adı</th>
              <th>Yetkili Email</th>
              <th>Oluşturduğu Düğünler</th>
              <th>Kalan Kredisi</th>
              <th>Kayıt Tarihi</th>
              <th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {orgs.length === 0 ? (
              <tr><td colSpan="6">Hiç organizasyon yok.</td></tr>
            ) : (
              orgs.map(org => (
                <tr key={org._id}>
                  <td><strong>{org.name}</strong><br/><small>{org.contactName}</small></td>
                  <td>{org.userEmail || org.email}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span className="badge badge-success">{org.credits} Kalan</span>
                      <button 
                        onClick={() => handleUpdateCredits(org, -1)} 
                        title="1 Kredi Düşür"
                        style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#ef4444', color: 'white', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
                        -
                      </button>
                      <button 
                        onClick={() => handleUpdateCredits(org, 1)} 
                        title="1 Kredi Ekle"
                        style={{ width: '24px', height: '24px', borderRadius: '50%', background: '#22c55e', color: 'white', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold' }}>
                        +
                      </button>
                    </div>
                  </td>
                  <td>{new Date(org.createdAt).toLocaleDateString('tr-TR')}</td>
                  <td>
                    <button
                      onClick={() => handleDelete(org)}
                      className="btn"
                      style={{ background: '#ef4444', color: 'white', padding: '4px 12px', fontSize: '12px', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
                    >
                      Sil
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button onClick={() => { setIsModalOpen(false); setCreationResult(null); }} className="modal-close-btn">&times;</button>
            
            {creationResult ? (
              <div>
                <h3 style={{color: 'green'}}>Organizasyon Başarıyla Oluşturuldu!</h3>
                <p>Müşterinize şu bilgileri gönderin:</p>
                <div style={{ background: '#f5f5f5', padding: '15px', borderRadius: '5px', marginTop: 10 }}>
                  <p><strong>Giriş Adresi:</strong> {window.location.origin}/organization/login</p>
                  <p><strong>E-Posta:</strong> {creationResult.user.email}</p>
                  <p><strong>Geçici Şifre:</strong> <span style={{color: 'red', fontWeight: 'bold'}}>{creationResult.user.temporaryPassword}</span></p>
                </div>
              </div>
            ) : (
              <form onSubmit={handleCreate}>
                <h2>Yeni Organizasyon Hesabı</h2>
                <div className="input-group">
                  <label>Firma Adı *</label>
                  <input type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} required />
                </div>
                <div className="input-group">
                  <label>Giriş E-postası *</label>
                  <input type="email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} required />
                </div>
                <div className="input-group">
                  <label>Yetkili Adı</label>
                  <input type="text" value={formData.contactName} onChange={e => setFormData({...formData, contactName: e.target.value})} />
                </div>
                <div className="input-group">
                  <label>Başlangıç Kredisi (Düğün Hakkı)</label>
                  <input type="number" min="0" value={formData.credits} onChange={e => setFormData({...formData, credits: e.target.value})} />
                </div>
                <button type="submit" className="btn" disabled={isSubmitting}>
                  {isSubmitting ? 'Oluşturuluyor...' : 'Hesap Oluştur'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
